// Phase I0.3 — HairlineRow primitive.
// 1px-divided table row; no alt-row striping. The divider is a top
// border so consecutive rows share a single hairline. Pass `first` to
// drop the top border on the first row in a list.

import type { CSSProperties, ReactNode } from "react";

export interface HairlineRowProps {
  children: ReactNode;
  /** When true, omits the top border (use for the first item in a list). */
  first?: boolean;
  /** Optional grid template for column-based rows. */
  columns?: string;
  /** Optional vertical padding (default 14px). */
  padY?: number;
  style?: CSSProperties;
}

export function HairlineRow({ children, first, columns, padY = 14, style }: HairlineRowProps) {
  return (
    <div
      style={{
        display: columns ? "grid" : "flex",
        gridTemplateColumns: columns,
        alignItems: "center",
        gap: 14,
        padding: `${padY}px 0`,
        borderTop: first ? "none" : "1px solid var(--sa-hairline)",
        ...style,
      }}
    >
      {children}
    </div>
  );
}
